import React, { useState } from "react";
import { useFormik } from "formik";
import { TailSpin } from "react-loader-spinner";
import { useNavigate, Link } from "react-router-dom";
import base_background from "../../assets/Base (1).png";
import main_logo from "../../assets/SM_Full_White-100 1 (1).png";
import arrow_forward from "../../assets/arrow_forward.png";
import arrow from "../../assets/Vector (1).png";
import passwordIcon from "../../assets/visibility_lock (1).png";
import * as yup from "yup";
// import { useAlert } from "react-alert";
import { useAlert } from "components/UI_components/Alert";
import { BASE_URL } from "utils/constant";

export function VerifyOTP() {
    const navigate = useNavigate();
    const [spinner, setSpinner] = useState(false);
    // const alert = useAlert();
    const { addAlert } = useAlert();
    const [otp, setOtp] = useState(["", "", "", ""]);
  
    const handleChange = (element, index) => {
      if (isNaN(element.value)) return false;
      
      setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
      
      // Focus next input
      if (element.nextSibling && element.value !== "") {
        element.nextSibling.focus();
      }
    };
  
    async function verifyOtp() {
      const email = localStorage.getItem("resetEmail");
      if (!email) {
        // alert.error("Email not found. Please restart the reset process.");
        addAlert("Email not found. Please restart the reset process.", "error");
        navigate("/forgot-password");
        return;
      }
  
      const otpValue = otp.join("");
      if (otpValue.length !== 4) {
        // alert.error("Please enter all 4 digits of the OTP");
        addAlert("Please enter all 4 digits of the OTP", "error");
        return;
      }
  
      setSpinner(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Accept", "application/json");
  
      var raw = JSON.stringify({
        email: email,
        otp: otpValue,
      });
  
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
  
      try {
        const response = await fetch(
          `${BASE_URL}/auth/otp-verify-password/`,
          requestOptions
        );
        const result = await response.json();
        
        if (result?.status) {
          // Store tokens for reset password api
          localStorage.setItem("resetAccessToken", result.data.access);
          localStorage.setItem("resetRefreshToken", result.data.refresh);
          navigate("/new-password");
        } else {
          // alert.error(result?.message || "Invalid OTP");
          addAlert(result?.message || "Invalid OTP", "error");
        }
      } catch (error) {
        console.log("error", error);
        // alert.error(error?.message || "Failed to verify OTP");
        addAlert(error?.message || "Failed to verify OTP", "error");
      } finally {
        setSpinner(false);
      }
    }
  
    return (
      <div
        className=""
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TailSpin
          visible={spinner}
          height="60"
          width="60"
          color="#3B0069"
          ariaLabel="tail-spin-loading"
          radius="1"
          wrapperStyle={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 100,
          }}
          wrapperClass=""
        />
        <div
          style={{
            position: "absolute",
            zIndex: -3,
            height: "100%",
            width: "50%",
            top: "0px",
            left: "0px",
          }}
        >
          <img
            src={base_background}
            alt=""
            style={{
              height: "140%",
              width: "140%",
              objectFit: "cover",
              position: "relative",
              top: "-50px",
              left: "-50px",
            }}
          />
        </div>
        <div
          style={{
            position: "absolute",
            zIndex: -3,
            height: "100%",
            width: "50%",
            top: "0px",
            left: "0px",
          }}
        >
          <img
            src={arrow}
            alt=""
            style={{
              height: "115%",
              width: "115%",
              top: "0px",
              left: "-70px",
              objectFit: "contain",
              position: "relative",
              opacity: "0.5",
            }}
          />
        </div>
        <div className="flex flex-col align-middle items-center justify-center w-[50%]">
          <span className="py-5 font-extrabold text-neutral-900 text-2xl">
            <img src={main_logo} alt="" width="90%" />
          </span>
          <span
            className="font-extrabold text-neutral-900  mt-[-2]"
            style={{
              fontSize: "28px",
              color: "#ffffff",
              fontWeight: 400,
              opacity: 0.8,
              letterSpacing: "0.1em",
              textAlign: "center",
            }}
          >
            Build Smarter,Faster,Better
          </span>
        </div>
        <div
          style={{
            width: "50%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            alignItems: "center",
            position: "relative",
            top: "70px",
            right: "50px",
          }}
        >
          {/* Back Button */}
          <Link
            to="/forgot-password"
            style={{
              position: "absolute",
              top: -40,
              left: 0,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            <img
              src={arrow_forward}
              alt="back"
              style={{
                transform: "rotate(180deg)",
                width: 24,
                height: 24,
                marginRight: 8,
              }}
            />
            <span style={{ color: "#3B0069", fontWeight: 500 }}>Back</span>
          </Link>
          <div
            className="flex flex-col align-middle justify-between px-10 pb-5"
            style={{ width: "80%" }}
          >
            <div className="flex flex-col">
              <span
                className="py-5 font-extrabold text-purple-800 text-2xl"
                style={{
                  color: "#3B0069",
                  fontSize: "32px",
                  fontWeight: 700,
                }}
              >
                Verify OTP
              </span>
              <span
                style={{
                  fontSize: "16px",
                  color: "black",
                  fontWeight: 200,
                  opacity: 0.8,
                  marginTop: "-12px",
                  marginBottom: "20px",
                }}
              >
                Please enter the 4-digit code sent to your email
              </span>
  
              <div className="flex justify-center items-center space-x-2 mb-5">
                {otp.map((data, index) => {
                  return (
                    <input
                      key={index}
                      className="bg-gray-200 rounded p-2 text-center font-bold text-lg"
                      type="text"
                      name="otp"
                      maxLength="1"
                      style={{ width: "50px", height: "50px" }}
                      value={data}
                      onChange={e => handleChange(e.target, index)}
                      onFocus={e => e.target.select()}
                    />
                  );
                })}
              </div>
            </div>
  
            <div className="w-full mt-10" style={{ width: "80%" }}>
              <button
                onClick={verifyOtp}
                className={`py-3 px-8 rounded-lg w-full justify-center items-center flex flex-row gap-4 text-center ${
                  otp.join("").length === 4 ? "bg-purple-950" : "bg-gray-400"
                }`}
                disabled={otp.join("").length !== 4 || spinner}
              >
                <span className="font-bold text-white text-lg">
                  {spinner ? "Verifying..." : "Verify OTP"}
                </span>
  
                <img
                  src={arrow_forward}
                  alt=""
                  className="w-6 h-6"
                  style={{ background: "#58267F", borderRadius: "50%" }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  